export enum ComplementActionOrigin {
  Internal = 'domain.enums.complement_action_origin.internal',
  PortoSchedule = 'domain.enums.complement_action_origin.porto_schedule',
  PortoBattery = 'domain.enums.complement_action_origin.porto_battery',
  MyBcs = 'domain.enums.complement_action_origin.my_bcs',
  Activity = 'domain.enums.complement_action_origin.activity',
  CheckList = 'domain.enums.complement_action_origin.check_list',
  Public = 'domain.enums.complement_action_origin.public',
}

export enum ComplementActionType {
  Opened = 'domain.enums.complement_action_type.opened',
  Authorized = 'domain.enums.complement_action_type.authorized',
  Cancelled = 'domain.enums.complement_action_type.cancelled',
  Closed = 'domain.enums.complement_action_type.closed',
  Reopened = 'domain.enums.complement_action_type.reopened',
}
